import { ErrorOutline } from '@mui/icons-material'
import { Box, Typography } from '@mui/material'

export const SurpassesThreshold = (props: { invert?: boolean }): JSX.Element => {
  const invert = props.invert === true
  const textColor = invert ? 'var(--blue-500)' : 'white'
  const bgColor = invert ? 'white' : 'var(--blue-500)'
  return <Box
    data-testid='surpasses-threshold-badge'
    sx={{
      px: '17px',
      py: '5px',
      borderRadius: '30px',
      bgcolor: bgColor,
      display: 'flex',
      alignItems: 'center',
      gap: '5px'
    }}
  >
    <ErrorOutline sx={{ color: textColor, accentColor: textColor, fontSize: '20px' }} />
    <Typography variant='h5' sx={{ color: textColor, fontWeight: 600, fontSize: '16px', lineHeight: '20px' }}>
      Surpasses 10% Threshold
    </Typography>
  </Box>
}
